import { FC, PropsWithChildren } from 'react';

import styles from './widget-edit-description.less';

const WidgetEditDescriptionText: FC<PropsWithChildren> = ({ children }) => (
    <div className={styles.widgetEditDescriptionText}>{children}</div>
);

export default WidgetEditDescriptionText;
